import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const KEY = "bionet_admin_token";
const KEY_USER = "bionet_admin_user";

export const adminAuth = {
  getToken() {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  getUser() {
    try {
      const u = localStorage.getItem(KEY_USER);
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  },
  setSession(token, user) {
    try {
      localStorage.setItem(KEY, token);
      localStorage.setItem(KEY_USER, JSON.stringify(user));
    } catch {
      /* ignore */
    }
  },
  clear() {
    try {
      localStorage.removeItem(KEY);
      localStorage.removeItem(KEY_USER);
    } catch {
      /* ignore */
    }
  },
};

export function adminAxios() {
  const token = adminAuth.getToken();
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export async function adminLogin(email, password) {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  adminAuth.setSession(res.data.access_token, res.data.user);
  return res.data;
}

export async function adminLogout() {
  adminAuth.clear();
}

export async function adminMe() {
  const res = await adminAxios().get("/auth/me");
  return res.data;
}
